module.exports = __webpack_public_path__ + "static/img/ms-puns-message.45be2ce1.svg";